import styled from '@emotion/styled';
import { colors, Stack, Typography } from '@ui-components/neo.tax';

import { KeywordSearch } from '../keyword-search';

export const EmptyStateOuter = styled(Stack)({
  flexGrow: 1,
});

export const EmptyStateInner = styled(Stack)({
  height: '66%',
});

export const ListFooterWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  flexGrow: 1,
  padding: '1rem',
});

export const MenuWrapper = styled(Stack)({
  height: '24rem',
  position: 'relative',
});

export const SearchWrapper = styled(Stack)({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  zIndex: 1,
  backgroundColor: colors.white,
});

export const StyledKeywordSearch = styled(KeywordSearch)({
  padding: '0.5rem',
});

export const ProjectList = styled(Stack)({
  display: 'block',
  overflowY: 'auto',
  flexGrow: 1,
  marginTop: 65,
});

export const TicketRowContainer = styled(Stack)({
  marginLeft: 16,
  maxHeight: 48,
});

export const TicketRowMainContent = styled(Stack)({
  flexGrow: 1,
});

export const TicketRowDetails = styled(Stack)({
  width: '0',
  flexGrow: 1,
});

export const TicketRowTitle = styled(Typography)({
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
});

export const TicketRowContributorName = styled(Typography)({
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  maxWidth: '200px',
  display: 'block',
});

export const ListFooterContainer = styled(Stack)({
  maxHeight: 28,
});

export const DisabledDot = styled('div')({
  width: '16px',
  height: '16px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  '&::before': {
    content: '""',
    width: '4px',
    height: '4px',
    borderRadius: '50%',
    backgroundColor: colors.black,
  },
});
